import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { setToken } from "scenes/redux";
import { createActionDispatchers } from "utils/reduxHelpers";
import { TransferContext } from "./types";

export type State = TransferContext;

export const initialState: State = {
  platform: "",
  application: "",
  cidpId: "",
  partnerId: "",
};

const slice = createSlice({
  name: "platformTransfer",
  initialState,
  // create actions with reducer (slice action) here
  reducers: {
    /** Stores platform, application, cidpId and partnerId together (hand-off to the access check). */
    setTransferContext(state, action: PayloadAction<TransferContext>) {
      state.platform = action.payload.platform;
      state.application = action.payload.application;
      state.cidpId = action.payload.cidpId;
      state.partnerId = action.payload.partnerId;
    },
  },
});

/**
 * actions from slice to be exported for saga
 */
export const { setTransferContext } = slice.actions;

/**
 * all actions for layout
 */
export const actionProps = createActionDispatchers(
  slice.actions,
  // slice actions
  ["setTransferContext"],
  // pure actions
  {
    setToken,
  }
);

export default slice.reducer;
